<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}}
      </template>
      <template slot="tab">
        <el-tabs v-model="tab">
          <el-tab-pane :label="$t('task.Product Installation')"
                       name="Product Installation"></el-tab-pane>
        </el-tabs>
      </template>
    </sub-header>
    <div class="main"
         :class="{'main-showfilter': filter.showFilter}">
      <div class="tool-btn">
        <el-button type="primary"
                   @click="openNewReport(1)"
                   v-has="'Create Report'"
                   :disabled="this.LRoption.taskIds.length === 0"
                   size="mini">{{$t('task.NewReport')}} </el-button>
        <span style="float: right;">
          <el-badge is-dot
                    class="item"
                    :hidden='this.hideFilterDot'>
            <el-button type="success"
                       style="float:right"
                       @click="openFilter()"
                       size="mini">{{$t('task.Filters')}}</el-button>
          </el-badge>
        </span>
      </div>
      <div class="report-content">
        <myScroll style="width:100%;height:100%">
          <div class="TaskReportVessel"
               id="TaskReportVessel">
            <div class="task-table"
                 v-loading="loading">
              <table class="NewGrB TaskGroupTable"
                     cellpadding="0"
                     cellspacing="0"
                     style="border-right:1px #999 solid;">
                <thead>
                  <tr style="background-color: #f2f2f2;">
                    <td class="tdHeader">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.Group')}} / {{$t('reportDialog.Plan')}}</div>
                    </td>
                    <td class="tdHeader">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.Area')}}</div>
                    </td>
                    <td v-if="LRoption.ShowProduct"
                        class="tdHeader">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.Product')}}</div>
                    </td>
                    <td v-else
                        class="tdHeader">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.Location')}}</div>
                    </td>
                    <td class="tdHeader">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.TotalQty')}}</div>
                    </td>
                    <td class="tdHeader"
                        style="min-width:50px">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.Installed')}}</div>
                    </td>
                    <td class="tdHeader"
                        style="width:70px">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.Status')}}</div>
                    </td>
                    <td class="tdHeader"
                        style="width:80px">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.StartDate')}}</div>
                    </td>
                    <td class="tdHeader"
                        style="width:80px">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.DueDate')}}</div>
                    </td>
                    <td v-if="LRoption.ShowProduct"
                        class="tdHeader"
                        style="min-width:70px">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.Assignee')}}</div>
                    </td>
                    <td class="tdHeader">
                      <div class="tdHeaderDivClass">{{$t('reportDialog.%Done')}}</div>
                    </td>
                  </tr>
                </thead>
                <template v-if="LRoption.ShowProduct">
                  <tbody v-for="group of reportData"
                         :key="group.PhaseId"
                         :label="group.Name">
                    <tr style="font-weight:bold;">
                      <td style="max-width:250px;">
                        <div class="tdBodyDivClass">{{ group.GroupName }}</div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass"></div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass"></div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass"></div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass"></div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass"></div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass"></div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass"></div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass"></div>
                      </td>
                      <td>
                        <div class="tdBodyDivClass">{{group.CompletionRate}}%</div>
                      </td>
                    </tr>
                    <template v-for="room of group.ReportRooms">
                      <tr v-bind:key="room.GroupKey">
                        <td style="padding:3px;max-width:250px;">
                          <div class="tdBodyDivClass">{{room.PlanName}}</div>
                        </td>
                        <td style="max-width:250px;">
                          <div class="tdBodyDivClass">{{room.RoomName}}</div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{room.CompletionRate}}%</div>
                        </td>
                      </tr>
                      <tr v-for="product of room.GroupReportRoomProducts"
                          :key="product.SKU">
                        <td style="padding:3px;max-width:250px;">
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td style="max-width:250px;">
                          <div class="tdBodyDivClass"></div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{product.ProductName}}</div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{product.TotQty}}</div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{product.QtyArea}}</div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{product.Status}}</div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{product.StartDate}}</div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{product.EndDate}}</div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{product.AssignedName}}</div>
                        </td>
                        <td>
                          <div class="tdBodyDivClass">{{product.CompletionRate}}%</div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tr v-if="reportData.length === 0">
                    <td colspan="9">{{$t('project.NoData')}}</td>
                  </tr>
                </template>
              </table>
            </div>
          </div>
        </myScroll>
      </div>
    </div>
    <filter-box :showFilter="filter.showFilter"
                @clearFilter="clearFilter()"
                @closeFilter="closeFilter()">
      <template slot="form">
        <el-form :model="taskCondition"
                 label-position="top"
                 size="mini"
                 ref="filter">
          <el-form-item :label="$t('task.Plan')"
                        prop="PlanId">
            <el-select v-model="taskCondition.PlanId"
                       filterable
                       remote
                       clearable
                       @visible-change="showSelect"
                       size="mini"
                       style="width:100%"
                       :remote-method="remotePlanMethod"
                       @change="search()">
              <el-option v-for="i of planList"
                         :key="i.PlanId"
                         :label="i.Name"
                         :value="i.PlanId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('task.TaskGroup')"
                        prop="GroupIds">
            <el-select :placeholder="$t('model.Select')"
                       v-model="taskCondition.GroupIds"
                       clearable
                       multiple
                       size="mini"
                       @change="search()">
              <el-option v-for="i of taskGroup"
                         :key="i.PhaseId"
                         :label="i.Name"
                         :value="i.PhaseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('task.Assignee')"
                        prop="AssignedUserIds">
            <el-select :placeholder="$t('model.Select')"
                       clearable
                       multiple
                       size="mini"
                       @change="search()"
                       v-model="taskCondition.AssignedUserIds">
              <el-option v-for=" i of projectUser"
                         :key="i.UserId"
                         :label="i.FullName"
                         :value="i.UserId">
                <div class="user-logo">
                  <img :src="i.AvatarUrl"
                       alt="">
                </div>
                <span style="margin-left:40px;">{{ i.FullName }}({{ i.LoginAccount }})</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </filter-box>
    <reportConditionDialog :showDialog="newReportDialog.show"
                           :type="newReportDialog.type"
                           :taskIds="newReportDialog.taskIds"
                           :planId="newReportDialog.planId"
                           @closeDialog="handleNewReportDialog">
    </reportConditionDialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { searchTaskIdList, getGroupReportDatas, getPlansList } from '@/api/config'
import reportConditionDialog from '@/components/report/reportConditionDialog.vue'
export default {
  data () {
    return {
      tab: 'Product Installation',
      loading: false,
      LRoption: {
        ShowProduct: true,
        reportData: [],
        taskList: [],
        taskIds: []
      },
      reportData: [],
      tick: 1,
      taskCondition: {
        AssignedUserIds: [],
        GroupIds: [],
        PlanId: '',
        Type: 1,
        PageIndex: 1,
        PageSize: 9999,
        GetChildTask: false,
        GetRecycle: false,
        IsApp: false,
        OrderBy: 'LastUpdatedOn desc'
      },
      filter: {
        showFilter: true
      },
      planList: [],
      planCondition: {
        Name: null,
        PageIndex: 1,
        PageSize: 20,
        OrderBy: 'CreatedOn desc'
      },
      newReportDialog: {
        show: false,
        type: 1,
        taskIds: [],
        planId: ''
      }
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'taskGroup', 'taskStatus', 'userInfo', 'projectUser']),
    hideFilterDot () {
      return (this.taskCondition.PlanId === '') &&
        (this.taskCondition.GroupIds.length === 0) &&
        (this.taskCondition.AssignedUserIds.length === 0)
    }
  },
  watch: {
  },
  created () {
    this.$store.dispatch('getProjectMember')
    this.getPlansList()
    this.$store.dispatch('getTasksStatus')
    this.$store.dispatch('getTaskGroup')
    let that = this
    that.loading = true
    this.search()
  },
  methods: {
    uniqueShapes (obj) {
      const res = new Map()
      return obj.filter((a) => !res.has(a.RoomShapeId + a.ShapeName) && res.set(a.RoomShapeId + a.ShapeName, 1))
    },
    getTaskListByCondition (callback) {
      let that = this
      if (this.userInfo.RoleType === 4) {
        this.taskCondition.OnlyMyTask = true
      }
      this.taskCondition.JobsiteId = this.jobsiteID
      this.loading = true
      this.reportData = []
      searchTaskIdList(this.taskCondition).then(res => {
        if (res.length > 0) {
          that.LRoption.taskIds = res
          callback()
        } else {
          that.LRoption.taskIds = []
          this.reportData = []
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    async getGroupReportDatas (tick) {
      this.reportData = []
      let that = this
      let taskCondition = {
        JobsiteId: this.jobsiteID,
        OrderBy: 'CreatedOn desc',
        ShowChecklist: false,
        ShowProduct: true,
        Type: 1,
        TaskIds: this.LRoption.taskIds
      }
      this.loading = true
      await getGroupReportDatas(taskCondition).then(async res => {
        if (res == null || (tick + 1) !== that.tick) {
          return
        }
        res.GroupReportPhases.forEach(async ele => {
          if (ele.DueDate) {
            ele.DueDate = this.$config.formatDate(new Date(ele.DueDate), 'MM/dd/yyyy')
          }
          if (ele.StartDate) {
            ele.StartDate = this.$config.formatDate(new Date(ele.StartDate), 'MM/dd/yyyy')
          }
          ele.CompletionRate = this.$config.getFormatNumber(ele.CompletionRate)
          if (ele.ReportTasks) {
            await ele.ReportTasks.forEach(async tele => {
              if (tele.EndDate) {
                tele.EndDate = this.$config.formatDate(new Date(tele.EndDate), 'MM/dd/yyyy')
              }
              if (tele.StartDate) {
                tele.StartDate = this.$config.formatDate(new Date(tele.StartDate), 'MM/dd/yyyy')
              }
              tele.CompletionRate = this.$config.getFormatNumber(tele.CompletionRate)
              if (tele.TaskSubtype === 1) {
                let unitStr = this.$config.getNonM2ProductUnit(tele.Unit)
                tele.TotQty = tele.TotQty + ' ' + unitStr
                tele.QtyArea = tele.QtyArea + ' ' + unitStr
              } else {
                let unit = tele.Unit
                let areaProductTypes = [1, 2, 3]
                if (areaProductTypes.indexOf(tele.ProductType) > -1) {
                  if (unit === 2) {
                    unit = 4
                  }
                  if (unit === 3) {
                    unit = 5
                  }
                }
                let totQty = this.$config.transformMMToM2Unit(tele.TotQty, unit)
                tele.TotQty = totQty.num + ' ' + totQty.text
                let qtyArea = this.$config.transformMMToM2Unit(tele.QtyArea, unit)
                tele.QtyArea = qtyArea.num + ' ' + qtyArea.text
              }
              if (!tele.ProductItems) {
                tele.ProductItems = []
              }
              tele.ProductItems.forEach(pele => {
                if (pele.TaskSubtype === 1) {
                  let unitStr = this.$config.getNonM2ProductUnit(pele.Unit)
                  pele.TotalQty = pele.TotalQty + ' ' + unitStr
                  pele.Installed = pele.Installed + ' ' + unitStr
                } else {
                  let unit = pele.Unit
                  let areaProductTypes = [1, 2, 3]
                  if (areaProductTypes.indexOf(pele.ProductType) > -1) {
                    if (unit === 2) {
                      unit = 4
                    }
                    if (unit === 3) {
                      unit = 5
                    }
                  }
                  let totalQty = this.$config.transformMMToM2Unit(pele.TotalQty, unit)
                  pele.TotalQty = totalQty.num + ' ' + totalQty.text
                  let installed = this.$config.transformMMToM2Unit(pele.Installed, unit)
                  pele.Installed = installed.num + ' ' + installed.text
                }
                pele.CompletionRate = this.$config.getFormatNumber(pele.CompletionRate)
                if (pele.EndDate) {
                  pele.EndDate = this.$config.formatDate(new Date(pele.EndDate), 'MM/dd/yyyy')
                }
                if (pele.StartDate) {
                  pele.StartDate = this.$config.formatDate(new Date(pele.StartDate), 'MM/dd/yyyy')
                }
              })
              tele.icon = 'special_0'
              tele.point = 'product'
              tele.color = this.$config.StatusColorProduct(tele.EndDate, tele.CompletionRate)
              tele.planUrl = null
              let shapesList = this.uniqueShapes(tele.TaskShapes)
              let roomShapeIdList = []
              shapesList.forEach(s => {
                roomShapeIdList.push(s.RoomShapeId)
              })
              tele.RoomShapeIdList = roomShapeIdList
              if (!tele.TaskChecklistItems) {
                tele.TaskChecklistItems = []
              }
              tele.groupTaskChecklists = []
              for (let item of tele.TaskChecklistItems) {
                let exsitGroup = tele.groupTaskChecklists.find(q => q.templateId === item.ChecklistTemplateId)
                if (!exsitGroup) {
                  tele.groupTaskChecklists.push({
                    templateId: item.ChecklistTemplateId,
                    templateName: item.ChecklistTemplateName,
                    items: [item]
                  })
                } else {
                  exsitGroup.items.push(item)
                }
              }
              that.LRoption.taskList.push(tele)
            })
          }
          if (ele.ReportRooms) {
            ele.ReportRooms.forEach(tele => {
              if (!tele.RoomName || tele.RoomName.length === 0) {
                tele.RoomName = 'None'
              }
              if (tele.EndDate) {
                tele.EndDate = this.$config.formatDate(new Date(tele.EndDate), 'MM/dd/yyyy')
              }
              if (tele.StartDate) {
                tele.StartDate = this.$config.formatDate(new Date(tele.StartDate), 'MM/dd/yyyy')
              }
              tele.CompletionRate = this.$config.getFormatNumber(tele.CompletionRate)
              tele.GroupReportRoomProducts.forEach(pele => {
                let unit = pele.Unit
                let areaProductTypes = [1, 2, 3]
                if (areaProductTypes.indexOf(pele.ProductType) > -1) {
                  if (unit === 2) {
                    unit = 4
                  }
                  if (unit === 3) {
                    unit = 5
                  }
                }
                let totQty = this.$config.transformMMToM2Unit(pele.TotQty, unit)
                pele.TotQty = totQty.num + ' ' + totQty.text
                let qtyArea = this.$config.transformMMToM2Unit(pele.QtyArea, unit)
                pele.QtyArea = qtyArea.num + ' ' + qtyArea.text
                pele.CompletionRate = this.$config.getFormatNumber(pele.CompletionRate)
                if (pele.EndDate) {
                  pele.EndDate = this.$config.formatDate(new Date(pele.EndDate), 'MM/dd/yyyy')
                }
                if (pele.StartDate) {
                  pele.StartDate = this.$config.formatDate(new Date(pele.StartDate), 'MM/dd/yyyy')
                }
              })
            })
          }
        })
        res.GroupReportPhases.forEach(g => {
          if ((g.ReportRooms && g.ReportRooms.length > 0)) {
            that.reportData.push(g)
          }
        })
        this.loading = false
      })
    },
    showSelect (e) {
      if (!e) {
        this.planCondition.Name = null
        this.getPlansList()
      }
    },
    async openFilter () {
      this.filter.showFilter = true
    },
    clearFilter () {
      this.$refs['filter'].resetFields()
      this.search()
    },
    closeFilter () {
      this.filter.showFilter = false
    },
    remotePlanMethod (query) {
      this.planCondition.Name = query
      this.getPlansList()
    },
    search () {
      let that = this
      let tick = that.tick
      this.getTaskListByCondition(function () {
        if (tick + 1 === that.tick) {
          that.getGroupReportDatas(tick)
        }
      })
      that.tick++
    },
    getPlansList () {
      this.planCondition.JobsiteId = this.jobsiteID
      getPlansList(this.planCondition).then(res => {
        this.planList = res.Data
      })
    },
    openNewReport (type) {
      if (this.LRoption.taskIds.length === 0) {
        this.$notify.info({
          title: this.$t('task.NoTasksFound', [this.$t('task.Product Installation')])
        })
      } else {
        this.newReportDialog.taskIds = this.LRoption.taskIds
        this.newReportDialog.type = type === 1 ? 1 : type === 2 ? 4 : 5
        this.newReportDialog.show = true
      }
    },
    handleNewReportDialog (needRefresh) {
      this.newReportDialog.show = false
      if (needRefresh === true) {
        this.$notify({
          title: this.$t('task.NewReport') + ' ' + this.$t('api.Successfully'),
          type: 'success',
          showClose: false,
          duration: 3000
        })
      }
    }
  },
  components: {
    reportConditionDialog
  }
}
</script>

<style  lang="scss" scoped>
.report-content {
  height: 100%;
  min-width: 600px;
  width: 100%;
  font-family: Arial, Helvetica, "Source Sans Pro", "Helvetica Neue", sans-serif;
  font-weight: 400;
  overflow-x: hidden;
  overflow-y: auto;
  color: #303133;
  background: #fff;
  word-break: break-word;
  .TaskReportVessel {
    padding: 0 15px;
    border: 0px #3817b0 solid;
    margin: 0 auto;
    overflow: hidden;
    .NewGrB {
      // border-collapse: collapse;
      margin: 15px 0px 0px 0px;
    }

    .NewGrB tr {
      margin: 0px;
      padding: 0px;
    }

    .NewGrB tr td {
      margin: 0px;
      padding: 0px;
      line-height: 26px;
      height: auto;
      min-height: 30px;
      // border: 1px #999 solid;
      font-size: 13px !important;
      vertical-align: middle;
    }

    .NewGrB tr .notborder {
      border: none;
    }

    .NewGrB tr .noHorizontalBorder {
      border-right: none;
      border-left: none;
    }

    .NewGrB tr th {
      line-height: 26px;
      height: 30px;
      // border: 1px #999 solid;
      font-size: 15px !important;
      vertical-align: top;
    }

    .taskItemClass {
      align-items: center;
      width: 100%;
      word-break: break-word;
      margin-left: 5px;
      min-height: 30px;
    }

    .taskItemTotalClass {
      align-items: center;
      width: 100%;
      font-weight: bold;
      margin-left: 5px;
      min-height: 30px;
    }

    .TaskTable {
      width: 60%;
      height: 100%;
      margin-left: 0;
      margin-bottom: 0px;
      border-bottom: 1px grey solid;
    }

    .TaskTableTitle {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: bold;
      font-size: 18px;
    }

    .TaskTable tr th,
    .TaskTable tr td {
      text-align: left;
      border: 0px;
      width: 15%;
      vertical-align: top;
    }

    .TaskTable tr,
    .TaskTable tr td {
      page-break-inside: avoid !important;
    }

    .TaskGroupTable {
      width: 100%;
      height: auto;
      margin-left: 0;
      margin-bottom: 15px;
      border-bottom: 1px grey solid;
      font-size: 15px;
      overflow: visible;
    }
    .TaskGroupTable tr td {
      border: 1px #666 solid;
    }
    .TaskGroupTable tr th,
    .TaskGroupTable tr td {
      text-align: center;
      border-right: 0px;
      border-bottom: 0px;
    }

    .tdHeader {
      line-height: 26px;
      height: 30px;
      font-size: 15px !important;
      vertical-align: top;
      font-weight: bold;
      word-break: break-word;
    }

    .caclAndRhHeadTr .tdHeader {
      line-height: 20px;
    }

    .tdHeaderDivClass {
      align-items: center;
      width: 100%;
    }

    .tdBodyDivClass {
      align-items: center;
      width: 100%;
      word-break: break-word;
    }
  }
}
.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
